import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { GeocodingModel } from 'src/app/models/location.model';
import { ExternalService } from 'src/app/services/external/external.service';
import * as stringSimilarity from "string-similarity";


@Component({
    templateUrl: './option-selector.component.html',
    styleUrls: ['./option-selector.component.scss'],
    selector: 'option-selector',
    providers: [
        {
          provide: NG_VALUE_ACCESSOR,
          multi:true,
          useExisting: OptionSelectorComponent
        },
        {
            provide: NG_VALIDATORS, 
            useExisting: forwardRef(() => OptionSelectorComponent),
            multi: true,
        },
    ]
})

export class OptionSelectorComponent implements ControlValueAccessor {
    form: UntypedFormGroup;

    // Data passed in by componentProps
    options:GeocodingModel[] = [];

    optionsFromFavorites:GeocodingModel[] = [];
    // optionsInput:any[] = [{name:'courses',key:'FJSDKFL'},{name:'dodo',key:'jklfjqmf'},{name:'rando',key:'jkmjfqdf'}];
    optionSelected = {};
    field:string = 'name';
    newValue:string;
    canCreate = false;
    multiSelect = false;

    onChange = (value) => {};
    onTouched = () => {};
    onValidationChange: any = () => {};

    touched = false;

    @Input()
    geoCode = true;

    @Input()
    value:GeocodingModel | any ;

    @Input()
    dataService: Promise<any>;

    @Input()
    title:string;

    @Input()
    placeholder:string;

    @Input()
    favorites:GeocodingModel[] = [];

    _locationTypes = ['houseNumber','street'];
    @Input('locationTypes')
    set locationTypes(value:[]){
        this._locationTypes = value;
        if(this.value && !this._locationTypes.includes(this.value.resultType)){
            this.value = null;
            this.form.patchValue(null);
        }
        this.onValidationChange();
        // console.log('locationtype set',this._locationTypes);
    }
    // locationTypes = ['houseNumber','street'];

    disabled = false;

    @Output() valueChanged = new EventEmitter<GeocodingModel>();


    constructor(private externalService:ExternalService,public formBuilder: UntypedFormBuilder) {
        this.setForm();
    }

    setForm(){
        this.form = this.formBuilder.group({
            label:['',[this.inputValidator()]]
        });
    }
  
    ionViewWillEnter() {

    }

    ngOnInit(){

    }

    filterByLabel(input:string){
        stringSimilarity.com
    }

    onInputChange(event){
        this.markAsTouched();
        if(this.canCreate){
            this.newValue = event.detail.value; //event.data.value;
        }
        if((!this.value || this.value.label !== event.detail.value ) && event.detail.value){
            
            if(this.favorites){
                const favoritesFiltered = this.favorites
                    .filter(item => this._locationTypes.includes(item.resultType))
                    .filter(favorite => {
                    const similarity =  stringSimilarity.compareTwoStrings(favorite.label.toLowerCase(),event.detail.value.toLowerCase());
                    // console.log(similarity,favorite.label,event.detail.value);
                    return similarity  > 0.15;
                });
                this.optionsFromFavorites = favoritesFiltered;
            }

            this.externalService.geocodeLocationWithHere(event.detail.value).then(results => {
                // console.log(results, this._locationTypes);
                this.options = results.filter(item => this._locationTypes.includes(item.resultType));
            })
        }
        // else if(this.options){
        //     const array = this.optionsInput.map(item=>item.name);
        //     const results = stringSimilarity.findBestMatch(event.detail.value,array).ratings;
        //     this.options = results.filter(item=>{
        //         return item.rating >= 0.5
        //     }).map(item => item.target)
        //     console.log(array, results,this.options);
        // }

    }

    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }

    onOptionSelected(item:GeocodingModel| any){
        // console.log(item, this.value);
        // this.value = item;
        this.writeValue(item);
        this.onChange(item);
        this.valueChanged.emit(item);
        this.onValidationChange();
        this.options = [];
        this.optionsFromFavorites = [];
    }

    setDisabledState(disabled: boolean) {
        // console.log('setDisabledState', disabled);
        this.disabled = disabled;
        if(disabled) this.form.disable();
    }

    writeValue(value: GeocodingModel| any) {
        //this.form.patchValue({label:null});
        //this.form.reset();
        // console.log('write value',value, this.form.valid);
        if(value){
            this.value = value;
            this.form.patchValue(value);
            //this.form.controls['label'].updateValueAndValidity();
        }
    }
    
    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }

    markAsTouched() {
        if (!this.touched) {
          this.onTouched();
          this.touched = true;
        }
    }

    validate(control?: AbstractControl): ValidationErrors {
        const validation = this.validateGeocodingType(this.value, this._locationTypes);
        const result = (validation?null:{invalidLocation:true});
        // console.log('validation result', result);
        return result;
    }
  
    validateGeocodingType(value:GeocodingModel,locationTypes){
        return value && locationTypes.includes(value.resultType)
    }

    registerOnValidatorChange?(fn: () => void): void {
        this.onValidationChange = fn;
    }

    inputValidator(): ValidatorFn  {
        return (control:AbstractControl) : ValidationErrors | null => {
            if(!this.value){
                return {label:{value:false}}
            }
            else if (!this._locationTypes.includes(this.value.resultType)){
                return {label:{value:this.value.label}}
            }
            else {
                return null
            }
        };
    }
  }